import {
  parseSearchBooleanValue,
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type { INewPatientsReportListFilters } from 'infrastructure/interfaces';

const defaultRange = 90;

const defaultFilter: INewPatientsReportListFilters = {
  reverse: false,
  range: defaultRange,
  page: 1,
};

const parseFunctions: TParseFunctions<INewPatientsReportListFilters> = {
  page: parseSearchNumberValue,
  range: parseSearchNumberValue,
  doctorGuid: parseSearchStringValue,
  patientGuid: parseSearchStringValue,
  clinicGuid: parseSearchStringValue,
  reverse: parseSearchBooleanValue,
};

export const useNewPatientsQueryFilter = () => {
  return useQueryFilterNew<INewPatientsReportListFilters>(
    defaultFilter,
    parseFunctions,
    ['page'],
  );
};
